import { combineReducers } from 'redux'

import { IAltenarState } from '../types'
import communications from './communications'
import data from './data'

export const reducer = combineReducers<IAltenarState>({
  communications,
  data,
})
